module.exports = __webpack_public_path__ + "img/boxed-bg.7799dece.jpg";